import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import cn from 'classnames';
import Input from "../Input";
import DropdownClearButton from "./DropdownClearButton";
import createStyles from "../createStyles";
var useStyles = createStyles(function (theme) {
  return {
    root: _defineProperty({
      margin: "".concat(theme.spacer(1), "px 0")
    }, theme.breakpoints.create('sm'), {
      margin: "".concat(theme.spacer(2), "px 0")
    })
  };
}, {
  name: 'DropdownSearch'
});
var DropdownSearch = /*#__PURE__*/React.forwardRef(function DropdownSearchInput(_ref, ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? 'Search...' : _ref$placeholder,
      className = _ref.className,
      onClear = _ref.onClear;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Input, {
    ref: ref,
    value: value,
    onChange: onChange,
    placeholder: placeholder,
    className: cn(classes.root, className),
    suffix: /*#__PURE__*/React.createElement(DropdownClearButton, {
      show: !!value,
      asSuffix: true,
      onClick: onClear
    })
  });
});
DropdownSearch.displayName = 'DropdownSearchInput';
export default DropdownSearch;